import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/models/users/users';
import { environment } from 'src/environments/environment.prod';

const SERVICE_NAME =  environment.SERVICE_NAME;

@Injectable({
  providedIn: 'root'
})

export class UserService {

  constructor(private http: HttpClient) {
  }


  gettUser(pagination?: any): Observable<User> {
    return this.http.post<any>(SERVICE_NAME + 'listUsers', pagination);
  }

  changePasswordURL(email: string): Observable<User> {
    return this.http.post<any>(SERVICE_NAME + 'changePasswordURL', {email: email});
  }

  updatePassword(userPassword?: any): Observable<User> {
    return this.http.post<any>(SERVICE_NAME + 'updatePassword', userPassword);
  }

  changePassword(userPassword?: any): Observable<User> {
    return this.http.post<any>(SERVICE_NAME + 'changePassword', userPassword);
  }

  createUser(user?: any): Observable<User[]> {
    return this.http.post<any>(SERVICE_NAME + 'createUser', user);
  }

  viewUser(userId?: string): Observable<User> {
    return this.http.post<any>(SERVICE_NAME + 'getUserById', userId);
  }

  updateUser(user?: any): Observable<User[]> {
    return this.http.put<any>(SERVICE_NAME + 'updateUser', user);
  }

  deleteUser(user?: any): Observable<User[]> {
    return this.http.post<any>(SERVICE_NAME + 'deleteUser', {id: user});
  }

  postEmailId(userEmailId: string): Observable<User> {
    return this.http.post<any>(SERVICE_NAME + 'validateEmail', userEmailId);
  }



}
